<template>
<div id="shini_i_diski">
    <div class="info title clearfix" style="background: url('/static/img/general/shina.jpg') 0 0 no-repeat;background-position: center center;">
        <div class="wrapper clearfix">
            <div class="col-xs-120">
                <h1>Автомобильные шины. Авторезина.</h1>
            </div>
        </div>
    </div>
    <div class="container-fluid avtoservices-block">
        <h3 style="color: #4a80c6;"><center><br/>Вернем CashBack 10% при любой покупке + 500 рублей на счет за регистрацию.</center></h3>
    </div>
    <div class="category clearfix category-links" style="padding-bottom: 0px;">
        <div class="wrapper clearfix" style="padding-bottom: 20px;">
            <div class="col-xs-120 text_raw_main_div">
                <h2>Удобный выбор и заказ</h2>
                <ul>
                    <li>Выбирайте по типоразмерам авторезины, ее стоимости и наличию в магазинах нашего города</li>
                    <li>Подбирайте по марке и модели автомобиля (резина, которую рекомендуют автопроизводители)</li>
                    <li>Выбирайте автошины по стоимости – от недорогих бюджетных до премиум сегмента</li>
                    <li>Все формы оплаты за автошины и диски</li>
                </ul>
                <h2>Шины и диски для автомобилей</h2>
                <ul>
                    <li>Все марки и модели автомобильных колес. В наличии все типоразмеры.</li>
                    <li>Летняя резина</li>
                    <li>Зимняя шипованная и зимняя не шипованная резина</li>
                    <li>Эксклюзивные шины и диски – на заказ</li>
                </ul>
                <h2>Шиномонтаж</h2>
                <ul>
                    <li>Узнайте о специальных условиях на шиномонтаж для покупателей резины</li>
                    <li>Возможен самовывоз и доставка к Вам домой или на работу</li>
                    <li>Вы можете воспользоваться услугами <router-link to="/uslugi-s-vyezdom/shinomontazh-viezd/">мобильного шиномонтажа</router-link></li>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'ShiniDiski'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ShiniDiski.vue